import sectionTracker from './bam-event-tracking';
import StandingsApp from 'bdata-react-standings/dist/standings.bundle';
import MlbLinker from '../../../node_modules/mlb-linker/dist/index.bundle';
import DisplayAds from './displayAds';

const teamSlugs = window.MilbUtils && window.MilbUtils.teamIdToSlugMap;
const milbLinker = window.milbLinker || new MlbLinker(window, { isMilb: true, teamSlugs });

const {
    appContextParam,
    appView,
    locale,
    env,
    basename,
    route,
    rules,
    displayAdConfig,
    clubId,
    leagueId,
    teamName,
    teamNameDisplay,
    season,
    siteName,
    tz,
    date,
    tableType,
    advancedSplits,
    useDate,
    sportId,
    forceSecondHalf
} = window.serverVals || {};

const standingsConfig = {
    sportId,
    appView,
    appContext: 'milb',
    appContextParam,
    locale,
    env,
    mount: '#standings-app-root',
    basename,
    linker: milbLinker,
    route,
    leagueId,
    rules,
    displayAdConfig,
    teamSlugs,
    clubId,
    teamName,
    teamNameDisplay,
    season,
    siteName,
    momentTz: window.milbMoment,
    date,
    tz,
    tableType,
    advancedSplits,
    useDate,
    forceSecondHalf
};

const standingsApp = new StandingsApp(standingsConfig);

standingsApp.prefetch().then(() => {
    standingsApp.render();
    sectionTracker();

    if (displayAdConfig && displayAdConfig.standings) {
        DisplayAds.init(displayAdConfig.standings);

        const { mobileAdRefreshRate, desktopAdRefreshRate } = standingsApp.getAdRefreshRate() || {};
        if (mobileAdRefreshRate && desktopAdRefreshRate) {
            const adRefreshRate = (window.innerWidth < 568 ? mobileAdRefreshRate : desktopAdRefreshRate) * 1000;
            setInterval(() => {
                DisplayAds.refreshSlots(displayAdConfig.standings);
            }, adRefreshRate);
        }
    }
});
